import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgpTabPanel } from 'ng-primitives/tabs';

/**
 * The content for one `hh-tabs` tab. `value` must match the `value` of
 * the corresponding entry in the parent `hh-tabs`' `tabs` input.
 *
 * Resolves its active/hidden state from the ancestor `NgpTabset` via DI
 * — nothing needs wiring from `hh-tabs` itself, the same way
 * `NgpAccordionContent` finds its own accordion.
 */
@Component({
  selector: 'hh-tab-panel',
  standalone: true,
  imports: [NgpTabPanel],
  template: `
    <div class="hh-tab-panel" ngpTabPanel [ngpTabPanelValue]="value()">
      <ng-content />
    </div>
  `,
  styleUrl: './hh-tab-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HhTabPanelComponent {
  readonly value = input.required<string>();
}
